/**
 * Email template for transaction hash removal notification
 */

interface HashRemovalEmailData {
 userName: string;
 userEmail: string;
 amount: number;
 shares: number;
 network: string;
 deletedHash: string;
}

export const generateHashRemovalEmail = (data: HashRemovalEmailData) => {
 const { userName, amount, shares, network } = data;

 const subject = 'Transaction Hash Removed - Resubmission Required';

 const html = `
<!DOCTYPE html>
<html>
<head>
 <meta charset="utf-8">
 <meta name="viewport" content="width=device-width, initial-scale=1.0">
 <title>Transaction Hash Removed</title>
</head>
<body style="margin: 0; padding: 0; font-family: Arial, sans-serif; background-color: #f4f4f4;">
 <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f4f4f4; padding: 20px;">
 <tr>
 <td align="center">
 <table width="600" cellpadding="0" cellspacing="0" style="background-color: #ffffff; border-radius: 8px; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
 
 <!-- Header -->
 <tr>
 <td style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); padding: 40px 30px; text-align: center;">
 <h1 style="margin: 0; color: #ffffff; font-size: 28px; font-weight: bold;">
 Transaction Hash Removed
 </h1>
 </td>
 </tr>
 
 <!-- Content -->
 <tr>
 <td style="padding: 40px 30px;">
 <p style="margin: 0 0 20px; color: #333333; font-size: 16px; line-height: 1.6;">
 Dear ${userName},
 </p>
 
 <p style="margin: 0 0 20px; color: #333333; font-size: 16px; line-height: 1.6;">
 Your transaction hash has been removed from our system by an administrator. This allows you to resubmit your payment with a different transaction hash.
 </p>
 
 <!-- Payment Details Box -->
 <table width="100%" cellpadding="0" cellspacing="0" style="background-color: #f8f9fa; border-radius: 6px; margin: 30px 0;">
 <tr>
 <td style="padding: 20px;">
 <h3 style="margin: 0 0 15px; color: #667eea; font-size: 18px;">Original Payment Details</h3>
 <table width="100%" cellpadding="8" cellspacing="0">
 <tr>
 <td style="color: #666666; font-size: 14px; border-bottom: 1px solid #e0e0e0;">Amount:</td>
 <td style="color: #333333; font-size: 14px; font-weight: bold; text-align: right; border-bottom: 1px solid #e0e0e0;">$${amount.toFixed(2)}</td>
 </tr>
 <tr>
 <td style="color: #666666; font-size: 14px; border-bottom: 1px solid #e0e0e0;">Shares:</td>
 <td style="color: #333333; font-size: 14px; font-weight: bold; text-align: right; border-bottom: 1px solid #e0e0e0;">${shares}</td>
 </tr>
 <tr>
 <td style="color: #666666; font-size: 14px;">Network:</td>
 <td style="color: #333333; font-size: 14px; font-weight: bold; text-align: right;">${network}</td>
 </tr>
 </table>
 </td>
 </tr>
 </table>
 
 <div style="background-color: #fff3cd; border-left: 4px solid #ffc107; padding: 15px; margin: 20px 0; border-radius: 4px;">
 <p style="margin: 0; color: #856404; font-size: 14px; line-height: 1.6;">
 <strong> Action Required:</strong> Please resubmit your payment with the correct transaction hash.
 </p>
 </div>
 
 <h3 style="margin: 30px 0 15px; color: #333333; font-size: 18px;">Next Steps:</h3>
 <ol style="margin: 0 0 30px; padding-left: 20px; color: #333333; font-size: 15px; line-height: 1.8;">
 <li>Log in to your Aureus Alliance Holdings account</li>
 <li>Navigate to the Share Purchase section</li>
 <li>Submit your payment with the correct transaction hash</li>
 <li>Wait for admin approval</li>
 </ol>
 
 <div style="text-align: center; margin: 30px 0;">
 <a href="https://aureus.africa/dashboard" 
 style="display: inline-block; background: linear-gradient(135deg, #667eea 0%, #764ba2 100%); color: #ffffff; text-decoration: none; padding: 14px 30px; border-radius: 6px; font-weight: bold; font-size: 16px;">
 Go to Dashboard
 </a>
 </div>
 
 <p style="margin: 30px 0 0; color: #666666; font-size: 14px; line-height: 1.6;">
 If you have any questions or need assistance, please contact our support team.
 </p>
 </td>
 </tr>
 
 <!-- Footer -->
 <tr>
 <td style="background-color: #f8f9fa; padding: 30px; text-align: center; border-top: 1px solid #e0e0e0;">
 <p style="margin: 0 0 10px; color: #666666; font-size: 14px;">
 Best regards,<br>
 <strong>Aureus Alliance Holdings Team</strong>
 </p>
 <p style="margin: 10px 0 0; color: #999999; font-size: 12px;">
 This is an automated message. Please do not reply to this email.
 </p>
 </td>
 </tr>
 
 </table>
 </td>
 </tr>
 </table>
</body>
</html>
 `;

 const text = `
Transaction Hash Removed - Resubmission Required

Dear ${userName},

Your transaction hash has been removed from our system by an administrator. This allows you to resubmit your payment with a different transaction hash.

ORIGINAL PAYMENT DETAILS:
- Amount: $${amount.toFixed(2)}
- Shares: ${shares}
- Network: ${network}

 ACTION REQUIRED: Please resubmit your payment with the correct transaction hash.

NEXT STEPS:
1. Log in to your Aureus Alliance Holdings account
2. Navigate to the Share Purchase section
3. Submit your payment with the correct transaction hash
4. Wait for admin approval

If you have any questions or need assistance, please contact our support team.

Best regards,
Aureus Alliance Holdings Team

This is an automated message. Please do not reply to this email.
 `;

 return { subject, html, text };
};

